import { API_CALL } from '../middleware/api';
import { PatientNotification } from '../schemas';
import {
  PATIENT_PORTAL_LIST_NOTIFICATIONS,
  PATIENT_PORTAL_UPDATE_PATIENT_NOTIFICATIONS,
  PATIENT_PORTAL_UPDATE_PATIENT_SETTINGS,
} from './action-types';

export const patientPortalActions = {
  getNotifications: (start, end) => ({
    [API_CALL]: {
      endpoint: 'portal/groups/patient/notifications/',
      params:
        start && end
          ? {
            start,
            end,
          }
          : {},
      schema: [PatientNotification],
    },
    type: PATIENT_PORTAL_LIST_NOTIFICATIONS,
  }),
  actionUpdateProfile: data => ({
    [API_CALL]: {
      method: 'put',
      endpoint: 'portal/groups/patient/settings/profile/',
      data,
    },
    type: PATIENT_PORTAL_UPDATE_PATIENT_SETTINGS,
  }),
  actionUpdateNotifications: data => ({
    [API_CALL]: {
      method: 'put',
      endpoint: 'portal/groups/patient/settings/notifications/',
      data,
    },
    type: PATIENT_PORTAL_UPDATE_PATIENT_NOTIFICATIONS,
  }),
};
